angular.module('lf.common')

.directive('superform', function ($parse, gtmService) {

  var getErrorFieldsNames = function (controlsList) {
    var fieldsNames = [];
    _.each(controlsList, function (ctrl) {
      fieldsNames.push(ctrl.$name);
    });

    return fieldsNames;
  };

  var constructErrorMessage = function (fieldsNames, sufix) {
    var message = 'Field';
    message += (fieldsNames.length > 1) ? 's ' : ' ';
    message += fieldsNames.join(', ') +  ' ' + sufix;

    return message;
  }

  return {
    restrict: 'A',
    require: 'form',
    link: function (scope, el, attrs, FormCtrl) {
      var isLFDevice = lf.data.xhr.client.isDevice;
      var $submitButton = el.find('button[type=submit]');
      var submitFn;
      
      if (attrs.superformSubmit) {
        submitFn = $parse(attrs.superformSubmit, /* interceptorFn */ null, /* expensiveChecks */ true);
      }

      el.on('submit', function (e) {
        FormCtrl.$touched = true;

        // We need to force an event(s) on which angular commit ng-model values
        // This also fixes autofill issues where Angular doesn't know about autofilled inputs
        var inputsSelector = 'input:not([type=hidden]):not([type=submit]):not([type=reset]), select, textarea';
        if (attrs.ngModelOptions) {
          var event = scope.$eval(attrs.ngModelOptions).updateOn;
          el.find(inputsSelector).trigger(event);
        } else {
          el.find(inputsSelector)
            .trigger('blur')
            .trigger('input')
            .trigger('change')
            .trigger('keydown');
        }

        scope.$digest();

        if (el.hasClass('ng-invalid')) {
          e.preventDefault();
          var $div = el.find('.has-error:eq(0)');
          var scrollable = $div.parents('[scrollable]');
          var iscroll = scrollable.length && scrollable.data('iscroll');
          if (iscroll) {
            iscroll.scrollToElement($div[0], 300, 0, true);
          }

          var errorMessages = [];
          var uncaughtedControlsWithErrors = [];
          _.each(FormCtrl.$error, function (errorCtrls, errorkey) {
            switch (errorkey) {
              case 'required':
                errorMessages.push(constructErrorMessage(getErrorFieldsNames(errorCtrls), 'are required'));
                break;
              case 'checkCC':
              case 'cvc':
              case 'postalCode':
              case 'phoneNumber':
                errorMessages.push(constructErrorMessage(getErrorFieldsNames(errorCtrls), 'has invalid format'));
                break;
              default:
                uncaughtedControlsWithErrors = uncaughtedControlsWithErrors.concat(errorCtrls);
                break;
            }
          });
          if (uncaughtedControlsWithErrors.length) {
            errorMessages.push(constructErrorMessage(getErrorFieldsNames(uncaughtedControlsWithErrors), 'has errors'));
          }

          gtmService.pushFormError(FormCtrl.$name, errorMessages);
        } else {
          el.find('input:focus').blur();
          scope.$apply(function () {
            submitFn && submitFn(scope, { $event: e });
          });
        }

      });

      el.on('focus', 'input[name]:not([type=submit])', function (e) {
        var $input = $(e.target);

        var name = $input.attr('name');
        var field = FormCtrl[name];

        if (!field || field.$valid || field.$pristine) return;

        $input.on('input', onInput);

        function onInput () {
          if (field.$editing) return;
          field.$editing = true;
          $input.on('blur', onBlur);
          scope.$apply();
        }

        function onBlur () {
          field.$editing = false;
          $input.off('input', onInput);
          $input.off('blur', onBlur);
          scope.$apply();
        }
      });
      
    }
  };
});
